import { api } from './apiService';

export type CompanyProfileResponse = {
  company_name?: string;
  description?: string;
  core_values?: string[];
  location?: string | null;
  /** Public URL for company logo (if configured). */
  company_logo_url?: string | null;
  /** Tenant-scoped list for the Library article editor category select */
  article_categories?: string[];
  /** Tenant-scoped pool for article tag autocomplete (max 5 picks) */
  article_tags?: string[];
};

export async function fetchCompanyProfile(): Promise<CompanyProfileResponse | null> {
  try {
    return (await api.get('/api/config/company-profile')) as CompanyProfileResponse;
  } catch {
    return null;
  }
}
